import { NavLink } from "react-router-dom";
import { styled } from "@mui/material";

export const StyledNavLink = styled(NavLink)`
  display: inline-flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  padding: ${({ theme }) => theme.spacing(1)};
  vertical-align: middle;
`;
